module.exports = __webpack_public_path__ + "static/gallery_12-18633ffb3bbde2e5e6012b39dedc2e99.jpg";